/**
 * 画面表示モード
 */
const OrderQuotableCode = {
  /** 注文 */
  ORDER: '0',
  /** 問い合わせ */
  QUOTABLE: '1',
  /** その他 */
  OTHER: '2',
} as const;

type OrderQuotableCode = typeof OrderQuotableCode[keyof typeof OrderQuotableCode];
export default OrderQuotableCode;
